import { select } from 'd3';
import i18n from 'i18next';

const gridData = ({ origin, yData, xData, gridWidth, gridHeight, yValues, xValues }) => {
  const leftTopCoordinate = origin || { x: 10, y: 10 };
  const gridCellWidth = gridWidth || 13;
  const gridCellHeight = gridHeight || 13;

  const data = [];
  let xpos = leftTopCoordinate.x;
  let ypos = leftTopCoordinate.y;

  // iterate for rows
  for (let row = 0; row < yData.length; row++) {
    data.push([]);
    // iterate for cells/columns inside rows
    for (let column = 0; column < xData.length - 1; column++) {
      data[row].push({
        x: xpos,
        y: ypos,
        width: gridCellWidth,
        height: gridCellHeight,
        row: row,
        yValue: yValues[row],
        xValue: xValues[column],
      });
      // increment the x position. I.e. move it over by width variable
      xpos += gridCellWidth;
    }
    // reset the x position after a row is complete
    xpos = leftTopCoordinate.x;
    // increment the y position for the next row. Move it down height variable
    ypos += gridCellHeight;
  }
  return data;
};

//Draw grid
export const generateGrid = ({ svgViewBox, yValues, xValues, theme, ...rest }) => {
  const svg = select('div#chartContainer')
    .append('svg')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .attr('viewBox', svgViewBox)
    .attr('class', 'svg-content');

  // Draw Y axis labels
  svg
    .selectAll('.yValue')
    .data(yValues)
    .enter()
    .append('text')
    .attr('x', (d) => d.x)
    .attr('y', (d) => d.y)
    .text((d) => i18n.t(d.key))
    .attr('font-size', '0.3rem')
    .attr('fill', theme.palette.grey.color);

  // Draw X axis labels
  svg
    .selectAll('.xValue')
    .data(xValues)
    .enter()
    .append('text')
    .attr('x', (d) => d.x)
    .attr('y', (d) => d.y)
    .text((d) => d.text)
    .attr('font-size', '0.3rem')
    .attr('fill', theme.palette.grey.color);

  // Generate grid
  const row = svg
    .selectAll('.row')
    .data(gridData({ yValues, xValues, ...rest }))
    .enter()
    .append('g')
    .attr('class', 'row');

  const column = row
    .selectAll('.column')
    .data((d) => d)
    .enter()
    .append('g');

  column
    .append('rect')
    .attr('class', 'square')
    .attr('x', (d) => d.x)
    .attr('y', (d) => d.y)
    .attr('width', (d) => d.width)
    .attr('height', (d) => d.height)
    .attr('stroke', theme.palette.grey.color)
    .style('stroke-width', '0.4');

  // Grid lines inside each cell
  const lines = [
    (d) => ({
      x1: d.x + d.width / 4,
      x2: d.x + d.width / 4,
      y1: d.y + (d.height * 3) / 4,
      y2: d.y + d.height,
    }),
    (d) => ({
      x1: d.x + d.width / 2,
      x2: d.x + d.width / 2,
      y1: d.y + d.height / 2,
      y2: d.y + d.height,
    }),
    (d) => ({
      x1: d.x + (3 * d.width) / 4,
      x2: d.x + (3 * d.width) / 4,
      y1: d.y + (3 * d.height) / 4,
      y2: d.y + d.height,
    }),
  ];

  lines.forEach((lineFn) => {
    column
      .append('line')
      .attr('x1', (d) => lineFn(d).x1)
      .attr('x2', (d) => lineFn(d).x2)
      .attr('y1', (d) => lineFn(d).y1)
      .attr('y2', (d) => lineFn(d).y2)
      .attr('stroke', theme.palette.grey.color)
      .style('stroke-width', '0.5');
  });
};
